import {useEffect, useState} from 'react'
import {useStoreDetailsStore} from '../../../../store/hooks/useStore'
import {StoreDetailResponseItem, SeasonalHours} from '../../../../types/store/storeDetails'
import {flowResult} from 'mobx'
import useCustomSitePreference from '../../../../hooks/forms/useCustomSitePreference'

export const useStoreDetails = (id: string) => {
  const enableSeasonalOpeningHours = useCustomSitePreference('enableSeasonalOpeningHours', false)
  const {currentSearch, findStore, getSeasonalHours} = useStoreDetailsStore()
  const [store, setStore] = useState<StoreDetailResponseItem | null>(null)
  const [seasonalHours, setSeasonalHours] = useState<SeasonalHours[] | null>(null)
  const [loading, setIsLoading] = useState<boolean>(false)

  useEffect(() => {
    ;(async function () {
      if (!id) return
      setStore(null)
      setIsLoading(true)
            
      const storeInSearch = currentSearch.find((store) => store.id === id)
      if (storeInSearch) {
        setStore(storeInSearch)
        setIsLoading(false)
        return
      }

      const details = await flowResult(findStore(id))
      setStore(details  as StoreDetailResponseItem)
      setIsLoading(false)

    })()
  }, [id])

  useEffect(() => {
    ;(async function () {
      if(enableSeasonalOpeningHours){
        const seasonalHours = await flowResult(getSeasonalHours(id))
        setSeasonalHours(seasonalHours as SeasonalHours[])
      }
    })()
  }, [enableSeasonalOpeningHours])

  return {store, loading, seasonalHours}
}

